import { doAction, logText, moveTo, getPlayerIndex, allCards, getNeutralZone, checkForReactions, getCard } from "./game.js";
import { hn, resolveEffects, resolveCount, testNum, resolveLocCondition, ongoingEffects, resolveExactCard, countMatches, doActionPause, resolveCondition, addCardsToCache, resolveExclude, resolveObject, currentCard, otherPlayer, cardsAtLocation } from "./parse.js";
import { chooseCards, info, pause, convert, choose, cc } from "./ui.js";
import { get } from 'svelte/store';
import { clone, res, state, ui, prefs, live } from './stores.js';
import { cardsInPlay, closeLook, dismissCard, lookAtCards, matches, myAway, possArray, typeOfGain } from "./card_actions.js";
import { element, tick } from 'svelte/internal';
import { ongoingPlayer, captainLogVerb, botLogsFromPlay } from "./parse.js";
import { allBeamed, allScoreableCards } from "./scores.js";
import { resolveCountTypes } from "./parse.js";
import {
    substitutions, allocate, adjust, canAdjust, adjustable, spendingSubstitutions,
    spendOrder, spendFrom, normaliseResource, BUILTIN_SUBSTITUTIONS
} from "./spend_as.js";

export function discountableCost(cost, type){
    if(type === true) type = ['dilithium', 'latinum', 'incident']; // Default
    if(cost.type == 'spend' && possArray(type).some(t => cost.resource == t)) return true;
    if(possArray(type).includes('incident') && cost.type ==  'action' && cost.action && cost.action.verb == 'take' && cost.action.obj && cost.action.obj.types == 'incident') return true;
    return false;
}

async function devCost(p, c){
    if(!c) return false;
    let possible = get(res).parsedCardText[c.id];
    if(!possible || !possible.effects) return false;
    let costs = possible.effects.filter(e => e.type == 'dev_cost').flatMap(d => d.cost);
    let computedCosts = [];
    let card = c;
    for(let c of costs){
        if(c.free) continue; // Don't count a free cost
        if(c.alternative){
            // There are alternatives here and so we automatically go with the cheapest one
            if(c.alternative.type == 'in_play'){
                if(!cardsInPlay(p).some(card => matches(card, c.alternative.card.card))){
                    computedCosts.push(...c.normal);
                }
                // Silent else: the otherwise means 'free'
            }else if(c.alternative.type == 'in_deck'){
                if(!p.decks[c.alternative.deck].some(card => matches(card, c.alternative.card.card))){
                    computedCosts.push(...c.normal);
                }
            }else if(c.alternative.type == 'away_team'){
                let card = allCards().find(cd => matches(cd, c.alternative.card.card));
                if(myAway(p, card) && testNum(c.alternative.num, myAway(p, card))){
                    console.log('card is free to develop!')
                }else{
                    computedCosts.push(...c.normal);
                }
            }else if(c.alternative.type == 'dismiss_duty'){
                if(p.decks.duty.some(cd => matches(cd, c.alternative.card))){
                    computedCosts.push(...c.alternative);
                }else{
                    computedCosts.push(...c.normal);
                }
            }else if(c.alternative.type == 'reduced'){
                //console.log('Not implemented yet...!')
                let should_do = await resolveCondition(p, c, c.alternative.cond, false);
                if(should_do){
                    computedCosts.push(...c.alternative.reduced);
                }else{
                    computedCosts.push(...c.normal);
                }
            }else if(c.alternative.type == 'condition'){
                if(!await resolveCondition(p, c, c.alternative.cond, false)){
                    computedCosts.push(...c.normal);
                }
                // silent = free
            }
        }else if(c.plus){
            let should_add = await resolveCondition(p, c, c.plus.condition, false);
            if(should_add){
                if(c.resource == c.plus.resource){
                    // Merge
                    computedCosts.push({...c, num: c.num + c.plus.num, plus: undefined}); // 
                }else{
                    computedCosts.push({...c.plus, condition: undefined})
                    computedCosts.push({...c, plus: undefined}); // 
                }
            }else{
                computedCosts.push({...c, plus: undefined});
            }
        }else if(c.per){
            let num = await resolveCount(p, card, c.per);
            if(num > 0) num = Math.floor(num);
            computedCosts.push({...c, num: c.num * num});
        }else{
            computedCosts.push(c);
        }
    }
    return computedCosts;
}

async function applyReductions(p, cost, r, per = false, card = false){
    if(!Array.isArray(r)) r = [r];
    let options = [];
    let current = [];
    for(let o of r){
        if(o.separator == 'or'){
            // close previous current and start a new one
            options = [...options, current];
            current = [];
        }
        current = [...current, o];
    }
    options = [...options, current];
    let choice = options[0];
    let count = 1;
    if(per){
        count = await resolveCount(p, p.decks.captain[0] || cardsInPlay(p)[0] || allScoreableCards(p)[0], per); // captain[0] is a bodge because it needs a card for cardOwner
    }

    cost = clone(cost);
    if(!Array.isArray(cost)) cost = [cost];

    for(let i = 0; i < count; i++){
        if(options.length > 0){
            let optionNames = options.flat(2).flatMap(o => {
                if(Array.isArray(o.types)){
                    return o.types.map(t => {
                        return {
                            option: {
                                num: o.num,
                                types: t
                            },
                            text: `${o.num} ${t.endsWith('movement') ? t : `[[${t}]]`}`
                        }
                    })
                }else{
                    return {
                        option: o,
                        text: `${o.num} ${o.types.endsWith('movement') ? o.types : `[[${o.types}]]`}`
                    }
                }
                
            })
            let origCost = await getCostInfo(p, cost, 'developing', card);
            //console.log(options, optionNames, count)
            choice = await choose(`Unreduced cost: ${renderCost(origCost) || 'unaffordable'}. Choose which cost reduction to apply${count > 1 ? ` (${i+1} of ${count})`: ''}:`, optionNames.map(o => o.text));
            choice = optionNames.find(o => o.text == choice);
            if(!choice) throw 'cancelled';
            choice = choice.option;
        }
    
        let consolidated = [];

        for(let c of cost){
            if(c.type == 'spend'){
                if(Array.isArray(choice)){
                    if(choice.some(o => o.types == c.resource)){
                        let o = choice.find(o => o.types == c.resource);
                        c.num -= o.num;
                        if(c.num < 0) c.num = 0;
                    }
                    consolidated.push(c);
                }else if(choice.types == c.resource){
                    c.num -= choice.num;
                    if(c.num <= 0){
                        c.num = 0;
                    }else{
                        consolidated.push(c);
                    }
                }else{
                    consolidated.push(c);
                }
                
            }else if(c.type == 'action' && c.action.verb == 'move'){
                let red = {};
                for(let h of possArray(choice)){
                    if(h.types.endsWith(' movement')){
                        if(!red[h.types]) red[h.types] = 0;
                        red[h.types] += h.num;
                    }
                }
                for(let o of possArray(c.action.obj)){
                    let toRemove = [];
                    for(let k of Object.keys(red)){
                        if(k == `[[${o.types}]] movement`){
                            o.num -= red[k];
                            if(o.num > 0){
                                toRemove.push(k); // no more deductions on this one
                            }else{
                                if(o.num < 0) red[k] = Math.abs(o.num); // Give the leftover back
                                o.num = 0;
                            }
                            if(c.action.text && c.action.text.toLowerCase().includes('move ')){
                                // rewrite
                                let text = c.action.text.split(' ');
                                let moveIndex = text.findIndex(t => t.toLowerCase().trim() == 'move');
                                text[moveIndex + 1] = `${o.num}`;
                                c.action.text = text.join(' ');
                            }
                        }
                    }
                    
                    for(let k of toRemove){
                        delete red[k];
                    }
                }
                if(!possArray(c.action.obj).every(o => o.num == 0)) consolidated.push(c);
            }else{
                consolidated.push(c);
            }
        }
        cost = consolidated; // so empty moves are removed
    }
    
    return cost;
}
const asyncFilter = async (arr, predicate) => 
	arr.reduce(async (memo, e) =>
		await predicate(e) ? [...await memo, e] : memo
	, []);

async function eligibleForDev(p, c, free = false){
    let cost = await devCost(p, c);
    if(!cost) return false;
    if(free) cost = cost.filter(c => !discountableCost(c, free));
    if(await canPay(p, cost, 'develop', c)) return true;
    return false;
}

export async function autoDevelop(p, free = false, reduction = false, available = false, noEnlistReactions = false){
    if(!p.decks.dev && (!available || available.length == 0)) return false;
    let lookSpecific = false;
    //let eligible = await Promise.all(p.decks.dev.filter(async c => c && (await devCost(p, c) && canPay(p, await devCost(p, c), 'develop') || reduction || free)));
    let eligible = await asyncFilter(p.decks.dev, async c => (await eligibleForDev(p, c, free) || reduction));
    if(available){
        if(!Array.isArray(available)) available = [available];
        //console.log('available limitations', available);
        eligible = eligible.filter(c => available.some(cd => cd == c.uniqueID));
        if(available.some(a => getCard(a).deck != p.captain)){
            // Off-deck developing
            eligible = await asyncFilter(available.map(a => getCard(a)), async c => (await eligibleForDev(p, c, free) || reduction));
            //lookSpecific = true;
        }
    }
    console.log('dev costs:', await Promise.all(eligible.map(async c => await devCost(p, c))));
    if(eligible.length == 0){
        logText(`No cards in development area that ${p.captain} can afford to develop, so not developing`);
        return false;
    }
    let l = lookAtCards(eligible);
    let c;
    if(available && eligible.length == 1){
        c = eligible[0];
    }else{
        if(free){
            if(free === true){
                c = await chooseCards(`Select a card to develop (ignoring resource and [[incident]] costs)`, eligible, { cancellable: true, cancel: 'Do not develop'});
            }else{
                c = await chooseCards(`Select a card to develop (ignoring ${possArray(free).map(f => `[[${f}]]`).join('/')} costs)`, eligible, { cancellable: true, cancel: 'Do not develop'});
            }
            
        }else{
            c = await chooseCards(`Select a card to develop`, eligible, { cancellable: true, cancel: 'Do not develop', liveInfo: (ui) => {
                    devCost(p, ui.selection).then(async cost => {
                        let info = convert(renderCost(await getCostInfo(p, cost, 'developing', ui.selection))+`${reduction ? ' (reductions calculated in next step)' : ''}`);
                        live.update(l => {
                            l.infoToDisplay = info;
                            return l;
                        })
                    });   
                    return true;
                }
            });
        }
    }
    if(!c || c == 'cancelled'){
        logText(`${p.captain} chose not to develop`);
        return false;
    }
    ui.update(ui => {
        ui.selection = false;
        return ui;
    });
    if(!get(res).BvB) await tick(); // To get rid of card tooltip
    closeLook(l);
    let cost = await devCost(p, c);
    if(reduction) cost = await applyReductions(p, cost, reduction.type, reduction.per, c);
    if(free) cost = cost.filter(c => !discountableCost(c, free));
    if(!await canPay(p, cost, 'developing', c)){
        await info('Unable to afford this development');
        return false;
    }
    let didIt = await pay(p, cost, 'developing', c)
    if(didIt){
        logText(`Developed ${cc(c)}`);
        //await doAction(p, 'enlist', {obj:c.uniqueID});

        if(!noEnlistReactions) await checkForReactions(p, 'enlist', {obj: c.uniqueID}, 'before');
        await moveTo(c, `players.deck.${getPlayerIndex(p)}`, 0);
        if(!noEnlistReactions){
            let action = ongoingEffects(c, 'on_enlist');
            if(action.length > 0){
                addCardsToCache(c, 'enlist'); // So on enlist effects trigger correctly
                logText(`${cc(c.uniqueID)} was enlisted, so performing enlist effect`);
                await doActionPause(); 
                await resolveEffects(c, action, action.some(a => a.attack), false); 
            }
            await checkForReactions(p, 'enlist', {obj: c.uniqueID}, 'after');
        }
        /*if(c && c.name == 'Murf'){
            // Add Murf to captain
            p.decks.captain[0].murf = true;
        }*/
        if(!get(res).BvB) await tick();
        return c.uniqueID;
    }else{
        return -1; // Means you cancelled payment, which in some cases can be interpreted as wanting to try again
    }
}

export function renderCost(info){
    if(!info) return '';
    //console.log('rendering cost', info)
    let elements = [];
    if(Array.isArray(info)){
        for(let i of info){
            elements.push(renderCost(i));
        }
        return `<span>${elements.join(' OR ')}</span>`;
    }
    info = normaliseCostInfo(info);
    // Show what actually leaves the player, naming the requirement when it is not the same
    // thing - otherwise a 2 [[dilithium]] cost paid in glory just reads '1 [[glory]]' and the
    // player cannot see which pile is about to drain.
    for(let r of spendOrder(Object.keys(info.spend))){
        if(r == 'actions') continue; // action costs have never been rendered
        let amount = info.spend[r];
        if(!amount) continue;
        let towards = spendingSubstitutions(info.alloc, r)
            .map(s => `${info.need[s.to]} [[${s.to}]]`);
        elements.push(`${amount} [[${r}]]${towards.length ? ` (for ${towards.join(' + ')})` : ''}`);
    }
    for(let a of info.additional){
        //console.log(a)
        if(a.text){
            elements.push(a.text);
        }else{
            elements.push(hn(a));
        }
    }
    if(elements.length == 0){
        return `<b><i>free!</i></b>`;
    }else{
        return `<span>${elements.join(', ')}</span>`;
    }
    
}

export async function pay(p, costs, purpose = false, card = null){
    let toPay = await getCostInfo(p, costs, purpose, card);
    if(!toPay) return false;
    if(Array.isArray(toPay)){
        // Resolve choice. Picked by position, so two alternatives that happen to render the
        // same string do not both resolve to the first of them.
        let rendered = toPay.map(c => renderCost(c));
        let choice = await choose(`Choose which cost to pay:`, rendered);
        let picked = rendered.indexOf(choice);
        if(picked < 0) return false;
        toPay = toPay[picked];
    }
    if(toPay.convertible && toPay.adjustable){
        toPay = await pause(`Choose how to pay${purpose ? ' for '+purpose : ''}:`, {cost: toPay, cancellable: true});
        if(!toPay || toPay == 'cancelled') return false;
    }
    // A replayed choice log carries whatever shape the session that recorded it used.
    toPay = normaliseCostInfo(toPay);
    for(let r of spendOrder(Object.keys(toPay.spend))){
        let amount = toPay.spend[r];
        if(!amount) continue;
        // Whatever this resource stood in for gets a reaction window either side of the spend.
        let subs = spendingSubstitutions(toPay.alloc, r);
        for(let sub of subs) await substitutionReactions(p, r, sub.to, 'before');
        await doAction(p, 'spend_tokens', {token: r, amount});
        for(let sub of subs) await substitutionReactions(p, r, sub.to, 'after');
    }
    // 'As your first action of turn' stops applying once an action was required, whether or not
    // an action token is what ended up paying for it.
    if(toPay.need && toPay.need.actions > 0) delete p.firstAction;
    for(let a of toPay.additional){
        try{
            await resolveEffects(card, a);
        }catch(e){
            if(e == 'cancelled' || e == 'uncompleted'){
                logText('Unable to complete cost, so cancelling payment');
                ui.update(ui => {
                    delete ui.per;
                    return ui;
                })
                return false; // 
            }
        }
        
    }
    return true;
}

export async function canPay(p, costs, purpose = false, card = false){
    return await getCostInfo(p, costs, purpose, card);
}

// Fired either side of spending a resource that stood in for another.
async function substitutionReactions(p, from, to, when){
    await checkForReactions(p, 'spend_sub', {payType: from, subTypes: to}, when);
    // 'When you spend [[glory]] in place of X' predates the general hook and is what the cards
    // already in the box are written against, so it keeps firing on its own terms.
    if(from == 'glory') await checkForReactions(p, 'glory_sub', {subTypes: to}, when);
}

// Resources that were objects of {raw, asGlory, origCost} in the pre-substitution cost info.
const LEGACY_TOKENS = ['dilithium', 'latinum'];

function builtinGloryRate(resource){
    let rule = BUILTIN_SUBSTITUTIONS.find(r => r.from == 'glory' && r.to == resource);
    return rule ? rule.get : 1;
}

/**
 * A cost info object is a replayable choice: it goes into the choice log, is serialised for
 * network play, and comes back to pay() on replay. Objects recorded before substitution was
 * generalised carry the old shape, so rebuild the allocation those fields implied rather than
 * re-solving - a replay must pay exactly what it paid the first time.
 */
export function normaliseCostInfo(info){
    if(!info || info.alloc) return info;
    let need = {};
    let alloc = {};
    let add = (to, from, units) => {
        if(!units || units < 0) return;
        if(!alloc[to]) alloc[to] = {};
        alloc[to][from] = (alloc[to][from] || 0) + units;
    };
    for(let r of LEGACY_TOKENS){
        let entry = info[r];
        if(!entry || typeof entry != 'object') continue;
        if(entry.origCost > 0) need[r] = entry.origCost;
        add(r, r, entry.raw || 0);
        // asGlory was counted in units of the cost resource, not in glory.
        if(entry.asGlory > 0) add(r, 'glory', Math.round(entry.asGlory / builtinGloryRate(r)));
    }
    if(info.glory > 0){
        need.glory = info.glory;
        add('glory', 'glory', info.glory);
    }
    for(let r of ['actions', 'whim']){
        if(info[r] > 0){
            need[r] = info[r];
            add(r, r, info[r]);
        }
    }
    return {...info, need, alloc, spend: spendFrom(alloc), rules: info.rules || [], wallet: info.wallet || {}};
}

// The +/- controls on the payment prompt. Free functions rather than closures stored on the
// cost info, because that object has to stay JSON round-trippable.
export function costAdjustments(info){
    if(!info) return [];
    return adjustable(normaliseCostInfo(info));
}

export function canAdjustCost(info, move){
    if(!info) return false;
    return canAdjust(normaliseCostInfo(info), move);
}

// Mutates in place: the payment prompt binds straight to the object it was handed.
export function adjustCost(info, move){
    let next = adjust(normaliseCostInfo(info), move);
    if(!next) return false;
    info.alloc = next.alloc;
    info.spend = next.spend;
    return true;
}

// Which substitutions this player may use, assembled once per cost rather than per resource:
// ongoingPlayer() is one of the hottest calls in the game.
function substitutionsFor(p){
    if(!p) return [];
    let ongoing = ongoingPlayer(p);
    let granted = [];
    if(ongoing.includes('spend_as')) granted.push(...ongoingPlayer(p, 'spend_as'));
    // 'You may spend [[whim]] as [[action]]' predates the general rule and is still read under
    // its own key in parse.js and card_actions.js, so translate it here rather than making
    // those readers depend on this one.
    if(ongoing.includes('whim_action')) granted.push({from: 'whim', to: 'actions', give: 1, get: 1});
    let blocked = [];
    if(ongoing.includes('no_spend_as')) blocked.push(...ongoingPlayer(p, 'no_spend_as'));
    if(ongoing.includes('no_glory_convert')){
        blocked.push(...ongoingPlayer(p, 'no_glory_convert').map(t => ({from: 'glory', to: t})));
    }
    // A bot gets only lossless rules - it never trades away a victory point. In practice it gets
    // none at all, since validEffect() withholds card ongoings from bots, so this is the builtin
    // glory table being filtered out.
    return substitutions(granted, blocked, {bot: !!p.bot});
}

function walletFor(p, need, rules){
    let wallet = {};
    for(let r of new Set([...Object.keys(need), ...rules.map(rule => rule.from)])){
        let held = p[r];
        if(typeof held == 'string') held = parseInt(held); // something upstream stringifies these
        wallet[r] = held > 0 ? held : 0;
    }
    return wallet;
}

// Work out how the whole cost's resource requirements get paid, in one go. Returns false if
// they cannot be, which is the caller's signal that the cost is unaffordable.
function applySpend(info, p, need, noSub){
    info.need = need;
    info.alloc = {};
    info.spend = {};
    info.rules = [];
    info.wallet = {};
    if(Object.keys(need).length == 0) return true;
    if(!p){
        // No player to check against: callers in this state are asking what a cost looks like,
        // not whether it can be met, so it reads as payable and fully adjustable.
        for(let r of Object.keys(need)) info.alloc[r] = {[r]: need[r]};
        info.spend = {...need};
        info.convertible = true;
        info.adjustable = true;
        return true;
    }
    info.rules = substitutionsFor(p);
    info.wallet = walletFor(p, need, info.rules);
    let result = allocate({need, wallet: info.wallet, rules: info.rules, noSub});
    if(!result.ok) return false;
    info.alloc = result.alloc;
    info.spend = result.spend;
    info.convertible = costAdjustments(info).length > 0;
    info.adjustable = info.convertible;
    return true;
}

export async function getCostInfo(p, costs, purpose = false, card = false){
    let info = {
        p,
        need: {},      // what the cost asks for, per resource
        alloc: {},     // which pile pays for which requirement: alloc[required][paidWith]
        spend: {},     // derived from alloc: what actually leaves the player
        rules: [],     // the substitutions in force while this cost was worked out
        wallet: {},    // what the player had to hand, for the +/- controls
        convertible: false,
        additional: []
    }
    if(!costs) return false;

    // Check reductions/adjustments first
    if(!Array.isArray(costs)) costs = [ costs ];

    for(let c of costs){
        if(c.choice){
            // Choice between, so return array
            // Weakness: can't have multiple bits of either/or. But I think that's ok
            // If it's not ok, we can duplicate the core info and overlay with each choice
            let options = [];
            for(let ch of c.choice){
                let element = await getCostInfo(p, ch, purpose, card);
                if(element) options.push(element);
            }
            if(options.length == 0) return false;
            console.log('choices', options);
            return options;
        }
    }

    // Every 'spend' item, gathered into one requirement map and solved together - a pile can be
    // contested between two requirements, so they cannot be settled one at a time. Done before
    // the branches below because an unaffordable cost has to bail out before the action costs
    // start prompting the player for cards they will not get to spend.
    let need = {};
    let noSub = [];
    for(let c of costs){
        if(c.type != 'spend' && c.verb != 'spend') continue;
        let r = c.resource;
        let num = c.num;
        if(c.verb == 'spend' && c.obj) r = c.obj;
        if(!Array.isArray(r)) r = [r];
        for(let resource of r){
            if(resource.num) num = resource.num;
            if(typeof resource == 'object') resource = resource.specific || resource.types; // TODO does this work for A/B?
            if(c.verb == 'spend' && c.obj) num = c.obj.num;
            resource = normaliseResource(resource);
            let all = (num == 'all');
            if(all) num = p ? (p[resource] || 0) : 0;
            if(!(num > 0)) continue;
            need[resource] = (need[resource] || 0) + num;
            // 'Spend all your X' is giving up the pile itself, so there is nothing to stand in
            // for it; noConversion says the same thing explicitly.
            if(c.noConversion || all) noSub.push(resource);
        }
    }
    if(!applySpend(info, p, need, noSub)) return false; // Can't pay

    for(let c of costs){
        if(c.type == 'spend' || c.verb == 'spend') continue; // settled above, in one go

        if(p && c.type == 'have'){
            let res = c.amount;
            if(!Array.isArray(res)) res = [res];
            for(let r of res){
                let count = 0;
                let type = r.type;
                if(type.types) type = type.types;
                if(type == 'assimilated'){
                    if(!p.decks.assimilated) return false;
                    if(r.filter){
                        count = countMatches(p, p.decks.assimilated, r.filter, {}, [], [], [], false, r.exclude || false);
                    }else{
                        count = p.decks.assimilated.length;
                    }
                          
                }else if(type == 'dev_empty'){
                    if(p.decks.dev.length > 1) return false; // Presume this is the only one
                }else if(type == 'away_count'){
                    let card = resolveExactCard(r.obj, 'cost', p);
                    if(typeof card == 'number') card = getCard(card);
                    if(card){
                        let away = myAway(p, card);
                        if(testNum(r.num, away)) return true;
                    }
                    return false;
                }else if(type.main && type.exclude || type == 'different species'){
                    let eligible = allScoreableCards(p);
                    if(r.loc) eligible = resolveLocCondition(false, r.loc, p, eligible);
                    if(type.exclude) eligible = eligible.filter(c => !matches(c, type.exclude));
                    if(r.completed) eligible = eligible.filter(c => c.complete);
                    let main = type.main || type;
                    count += countMatches(p, eligible, main); // to handle different species too
                }else if(type == 'card' || typeOfGain(type) == 'card' || Array.isArray(type) && type.every(t => typeOfGain(t) == 'card')){
                    let eligible = allScoreableCards(p);
                    if(r.loc) eligible = resolveLocCondition(false, r.loc, p, eligible);
                    if(r.exclude) eligible = resolveExclude(false, eligible, r.exclude);
                    if(r.completed) eligible = eligible.filter(c => c.complete);
                    if(!Array.isArray(r.type) && r.type.filter) eligible = eligible.filter(c => matches(c, r.type.filter));
                    if(type == 'card'){
                        count += eligible.length;
                    }else{
                        for(let c of eligible){
                            count += matches(c, type);
                        }
                    }
                }else{
                    count = p[r.type];  
                }
                if(r.num){
                    if(typeof r.num == 'number' && count < r.num) return false;
                    if(r.num.min && count < r.num.min) return false;
                    if(r.num.max && count > r.num.max) return false;
                }
            }
            
            // Otherwise silently continues, since it's a gatekeeping condition
        }else if(p && c.type == 'enlisted'){
            let eligible = allCards().filter(card => matches(card, c.obj));
            for(let card of eligible){
                let info = get(state).cardLog[card.uniqueID];
                if(info.deck == 'reserve' || info.deck == 'dev') return false;
            }
        }else if(p && c.type == 'loc_requirement'){
            let eligible = [];
            let mustBeSame = false;
            if(c.loc && c.loc.location == 'same'){
                // 'Have X at the same location', i.e.not a previous reference here but a shared reference
                eligible = [...getNeutralZone(), ...p.decks.locations, ...otherPlayer(p).decks.locations];
                if(c.loc.locType){
                    let locType = c.loc.locType;
                    eligible = eligible.filter(l => matches(l, `${locType} location`));
                }
                mustBeSame = true;
            }else{
                eligible = resolveLocCondition(false, c.loc, p, []);
            }
            let obj = c.obj;
            if(!Array.isArray(obj)) obj = [obj];
            for(let o of obj){
                let toMatch = false;
                let num = 1;
                if(o.hasOwnProperty('num')) num = o.num;
                if(o.card && o.card.type == 'card'){
                    toMatch = o.card.card;
                }else if(o.types){
                    toMatch = o.types;   
                }
                if(!toMatch) return false;
                if(mustBeSame){
                    eligible = eligible.filter(c => testNum(num, matches(cardsAtLocation(c, p), toMatch)));
                    if(eligible.length == 0) return false;
                }else{
                    if(!eligible.some(c => testNum(num, matches(c, toMatch)))) return false; // don't filter otherwise
                }
    
                
            }
        }else if(c.type == 'action'){
            let action = c.action || c;
            if(p && action.verb == 'log_assimilate') action = {...action, verb: captainLogVerb(p)};
            let type = action.verb;
            if(p && ['discard', 'top', 'log', 'assimilate', 'dismiss', 'recall'].includes(type)){
                let eligible = p.decks.hand;
                if(['dismiss', 'recall'].includes(type)) eligible = [...p.decks.play, ...p.decks.duty, ...p.decks.fleet, ...p.decks.locations, ...allBeamed(p)];
                if(action.from_duty) eligible = [...p.decks.duty];
                if(action.obj /*&& purpose == 'developing'*/){
                    // April 2025: uncomment 'purpose == developing' above if any cost effects on cards fail
                    // because of imperfect info at point of choosing resolution options
                    // Added prev_obj filter because it doesn't actually do the actions,
                    // so it can't generate backreferences.
                    if(!JSON.stringify(action.obj).includes('prev_obj') && (purpose != 'testing affordability' || botLogsFromPlay(p, type, action.obj, action))){
                        // Put 'testing affordability' exclusion because otherwise you are meaninglessly
                        // prompted for things like dismissing ships
                        
                        let params = {...action};
                        params.card = card ? card.uniqueID : currentCard() || false; // for autoCardActions etc.
                        let obj = await resolveObject(action.obj, action.verb, params, p, null, true);
                        if(['dismiss', 'recall'].includes(type)) obj = eligible.filter(e => possArray(obj).some(o => e.uniqueID == o));
                        if(!obj || obj.length < (action.obj.num ? (action.obj.num.min || action.obj.num) : 1)) return false; // Nothing there to go for
                        
                    }
                    
                }else{
                    if(action.from){
                        // work out how to do this without async...
                        // basically it's whether one or other of those places allows it

                    }else{
                        if(eligible.length < action.obj.num) return false;
                    }
                }
                info.additional.push(action);
            }else if(p && (type == 'find' || type == 'find_recall')){
                let eligible = [...p.decks.hand, ...p.decks.deck, ...p.decks.discard, ...p.decks.reserve];
                if(type == 'find_recall') eligible = [...eligible, ...cardsInPlay(p, true).filter(c => !p.decks.play.some(cd => cd.uniqueID == c.uniqueID))];
                if(action.obj && action.obj.types && !eligible.some(c => matches(c, action.obj.types))){
                    return false;
                }
                info.additional.push(action);
            }else if(type == 'take'){
                //if(get(state).commons.incidents.length < action.obj.num) return false;
                info.additional.push(action);
            }else if(type == 'expend'){
                let eligible = [...getNeutralZone(), ...cardsInPlay(p, false, true).filter(c => !ongoingEffects(c).includes('drone_alcoves'))];
                eligible = eligible.filter(c => c.drones && c.drones[p.captain]);
                if(eligible.length == 0){
                    return false;
                }
                let num = action.obj.num;
                if(Array.isArray(num)) num = Math.min(...num);
                if(!testNum(num, eligible.reduce((a,c) => a + c.drones ? c.drones[p.captain] : 0, 0))){
                    return false;
                }
                info.additional.push(action);
            }else if(type == 'move'){
                for(let o of possArray(action.obj)){
                    let met = false;
                    for(let t of possArray(o.types)){
                        if(p[t] >= o.num){
                            met = true;
                            break; // you can afford this option, so no need to carry on
                        }
                        if(!met) return false;
                    }
                }
                // if you're here, you've met all the requirements
                info.additional.push(action);
            }else{
                info.additional.push(action);
            }
        }else if(p && c.type == 'dismiss_duty'){
            if(!p.duty.some(c => matches(c, c.card))) return false;
            info.additional.push({
                type: 'action',
                verb: 'dismiss',
                obj: {
                    defaultNum: true,
                    num: 1,
                    card: {
                        type: 'card',
                        card: c.card,
                        card_itself: true
                    }
                }
            })
        }else if(p && c.type == 'ownership'){
            let obj = c.obj;
            if(!Array.isArray(obj)) obj = [obj];
            for(let o of obj){
                if(o.card && o.card.type == 'card'){
                    let cards = o.card.card;
                    if(!allScoreableCards(p).some(c => matches(c, cards))) return false;
                }
            }
        }else if(c.type == 'via_card'){
            if(get(state).cache && get(state).cache.cardID){
                let current = getCard(get(state).cache.cardID);
                if(matches(current, c.card)) continue;
            }
            return false;
        }
    }
        
    return info;
}
